// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { Vector3 } from './vector3';


export class AngleMeasurement {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
__init(i:number, bb:flatbuffers.ByteBuffer):AngleMeasurement {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsAngleMeasurement(bb:flatbuffers.ByteBuffer, obj?:AngleMeasurement):AngleMeasurement {
  return (obj || new AngleMeasurement()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsAngleMeasurement(bb:flatbuffers.ByteBuffer, obj?:AngleMeasurement):AngleMeasurement {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new AngleMeasurement()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

guid():string|null
guid(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
guid(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

imageGuid():string|null
imageGuid(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
imageGuid(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

label():string|null
label(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
label(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

color():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

isVisible():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

value():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
}

ptFrom(obj?:Vector3):Vector3|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? (obj || new Vector3()).__init(this.bb_pos + offset, this.bb!) : null;
}

ptMiddle(obj?:Vector3):Vector3|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? (obj || new Vector3()).__init(this.bb_pos + offset, this.bb!) : null;
}

ptTo(obj?:Vector3):Vector3|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? (obj || new Vector3()).__init(this.bb_pos + offset, this.bb!) : null;
}

partFromGuid():string|null
partFromGuid(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
partFromGuid(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

partMiddleGuid():string|null
partMiddleGuid(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
partMiddleGuid(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

partToGuid():string|null
partToGuid(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
partToGuid(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

isReflex():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

static startAngleMeasurement(builder:flatbuffers.Builder) {
  builder.startObject(13);
}

static addGuid(builder:flatbuffers.Builder, guidOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, guidOffset, 0);
}

static addImageGuid(builder:flatbuffers.Builder, imageGuidOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, imageGuidOffset, 0);
}

static addLabel(builder:flatbuffers.Builder, labelOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, labelOffset, 0);
}

static addColor(builder:flatbuffers.Builder, color:number) {
  builder.addFieldInt32(3, color, 0);
}

static addIsVisible(builder:flatbuffers.Builder, isVisible:boolean) {
  builder.addFieldInt8(4, +isVisible, +false);
}

static addValue(builder:flatbuffers.Builder, value:number) {
  builder.addFieldFloat64(5, value, 0.0);
}

static addPtFrom(builder:flatbuffers.Builder, ptFromOffset:flatbuffers.Offset) {
  builder.addFieldStruct(6, ptFromOffset, 0);
}

static addPtMiddle(builder:flatbuffers.Builder, ptMiddleOffset:flatbuffers.Offset) {
  builder.addFieldStruct(7, ptMiddleOffset, 0);
}

static addPtTo(builder:flatbuffers.Builder, ptToOffset:flatbuffers.Offset) {
  builder.addFieldStruct(8, ptToOffset, 0);
}

static addPartFromGuid(builder:flatbuffers.Builder, partFromGuidOffset:flatbuffers.Offset) {
  builder.addFieldOffset(9, partFromGuidOffset, 0);
}

static addPartMiddleGuid(builder:flatbuffers.Builder, partMiddleGuidOffset:flatbuffers.Offset) {
  builder.addFieldOffset(10, partMiddleGuidOffset, 0);
}

static addPartToGuid(builder:flatbuffers.Builder, partToGuidOffset:flatbuffers.Offset) {
  builder.addFieldOffset(11, partToGuidOffset, 0);
}

static addIsReflex(builder:flatbuffers.Builder, isReflex:boolean) {
  builder.addFieldInt8(12, +isReflex, +false);
}

static endAngleMeasurement(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

}
